const ShootoutIndicator = ({ score }) => {
  return (
    <>
      <p className="inline-flex mr-[2px]">{score === "1" ? <>🟢</> : <>❌</>}</p>
    </>
  );
};

export default ShootoutIndicator;
